module.exports = __webpack_public_path__ + "img/title2.199a840d.png";